import { i as confirmEmailChange, n as requestEmailChange, r as getProfile, t as updateProfile } from "./updateProfile.js";
import { mutationOptions, queryOptions, useMutation, useQuery } from "@tanstack/react-query";
//#region src/__generated__/external/profile/hooks/useConfirmEmailChange.ts
const confirmEmailChangeMutationKey = () => [{ url: "/api/mdm/external/api/external/profile/email/confirm" }];
function confirmEmailChangeMutationOptions(config = {}) {
	const mutationKey = confirmEmailChangeMutationKey();
	return mutationOptions({
		mutationKey,
		mutationFn: async ({ body }) => {
			const { data } = await confirmEmailChange({
				...config,
				body,
				throwOnError: true
			});
			return data;
		}
	});
}
/**
* @description Токен берётся из ссылки в письме на новый адрес.
* @summary Подтвердить смену email
* {@link /api/mdm/external/api/external/profile/email/confirm}
*/
function useConfirmEmailChange(options = {}) {
	const { mutation = {}, client: config = {} } = options ?? {};
	const { client: queryClient, ...mutationOptions } = mutation;
	const mutationKey = mutationOptions.mutationKey ?? confirmEmailChangeMutationKey();
	const baseOptions = confirmEmailChangeMutationOptions(config);
	return useMutation({
		...baseOptions,
		mutationKey,
		...mutationOptions
	}, queryClient);
}
//#endregion
//#region src/__generated__/external/profile/hooks/useGetProfile.ts
const getProfileQueryKey = () => [{ url: "/api/mdm/external/api/external/profile" }];
function getProfileQueryOptions(config = {}) {
	const queryKey = getProfileQueryKey();
	return queryOptions({
		queryKey,
		queryFn: async ({ signal }) => {
			const { data } = await getProfile({
				...config,
				signal: config.signal ?? signal,
				throwOnError: true
			});
			return data;
		}
	});
}
/**
* @description Регистрационные данные (Keycloak) + рабочие данные (ВТУ) текущего пользователя
* @summary Получить профиль
* {@link /api/mdm/external/api/external/profile}
*/
function useGetProfile(options = {}) {
	const { query: queryConfig = {}, client: config = {} } = options ?? {};
	const { client: queryClient, ...resolvedOptions } = queryConfig;
	const queryKey = resolvedOptions?.queryKey ?? getProfileQueryKey();
	const queryResult = useQuery({
		...getProfileQueryOptions(config),
		...resolvedOptions,
		queryKey
	}, queryClient);
	queryResult.queryKey = queryKey;
	return queryResult;
}
//#endregion
//#region src/__generated__/external/profile/hooks/useRequestEmailChange.ts
const requestEmailChangeMutationKey = () => [{ url: "/api/mdm/external/api/external/profile/email" }];
function requestEmailChangeMutationOptions(config = {}) {
	const mutationKey = requestEmailChangeMutationKey();
	return mutationOptions({
		mutationKey,
		mutationFn: async ({ body }) => {
			const { data } = await requestEmailChange({
				...config,
				body,
				throwOnError: true
			});
			return data;
		}
	});
}
/**
* @description Письмо-уведомление уходит на текущий адрес, ссылка для подтверждения — на новый. Email в Keycloak меняется только после подтверждения по ссылке.
* @summary Запросить смену email
* {@link /api/mdm/external/api/external/profile/email}
*/
function useRequestEmailChange(options = {}) {
	const { mutation = {}, client: config = {} } = options ?? {};
	const { client: queryClient, ...mutationOptions } = mutation;
	const mutationKey = mutationOptions.mutationKey ?? requestEmailChangeMutationKey();
	const baseOptions = requestEmailChangeMutationOptions(config);
	return useMutation({
		...baseOptions,
		mutationKey,
		...mutationOptions
	}, queryClient);
}
//#endregion
//#region src/__generated__/external/profile/hooks/useUpdateProfile.ts
const updateProfileMutationKey = () => [{ url: "/api/mdm/external/api/external/profile" }];
function updateProfileMutationOptions(config = {}) {
	const mutationKey = updateProfileMutationKey();
	return mutationOptions({
		mutationKey,
		mutationFn: async ({ body }) => {
			const { data } = await updateProfile({
				...config,
				body,
				throwOnError: true
			});
			return data;
		}
	});
}
/**
* @description Полная замена рабочих данных ВТУ. ФИО обновляется фронтом в Keycloak.
* @summary Обновить рабочие данные профиля
* {@link /api/mdm/external/api/external/profile}
*/
function useUpdateProfile(options = {}) {
	const { mutation = {}, client: config = {} } = options ?? {};
	const { client: queryClient, ...mutationOptions } = mutation;
	const mutationKey = mutationOptions.mutationKey ?? updateProfileMutationKey();
	const baseOptions = updateProfileMutationOptions(config);
	return useMutation({
		...baseOptions,
		mutationKey,
		...mutationOptions
	}, queryClient);
}
//#endregion
export { requestEmailChangeMutationOptions as a, getProfileQueryOptions as c, confirmEmailChangeMutationOptions as d, useConfirmEmailChange as f, requestEmailChangeMutationKey as i, useGetProfile as l, updateProfileMutationOptions as n, useRequestEmailChange as o, useUpdateProfile as r, getProfileQueryKey as s, updateProfileMutationKey as t, confirmEmailChangeMutationKey as u };

//# sourceMappingURL=useUpdateProfile.js.map